import React from "react";
import { Select } from "antd";

const { Option } = Select;

const options = [
  {
    value: "",
    label: "none",
    imgSrc:
      "https://plus.unsplash.com/premium_photo-1664474619075-644dd191935f?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8aW1hZ2V8ZW58MHx8MHx8fDA%3D",
  },
  {
    value: "jack",
    label: "Jack",
    imgSrc:
      "https://plus.unsplash.com/premium_photo-1664474619075-644dd191935f?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8aW1hZ2V8ZW58MHx8MHx8fDA%3D",
  },
  {
    value: "lucy",
    label: "Lucy",
    imgSrc:
      "https://plus.unsplash.com/premium_photo-1664474619075-644dd191935f?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8aW1hZ2V8ZW58MHx8MHx8fDA%3D",
  },
  {
    value: "Yiminghe",
    label: "Yiminghe",
    imgSrc:
      "https://plus.unsplash.com/premium_photo-1664474619075-644dd191935f?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8aW1hZ2V8ZW58MHx8MHx8fDA%3D",
  },
];

const ImageSelect = () => {
  return (
    <div className="img-select-col">
      <Select
        className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] py-[10px] px-[15px] border-1 border-transparent focus:border-white size-full bg-[#013351] placeholder-[#005A90] color-[#fff] h-auto"
        defaultValue=""
        style={{ width: "100%" }}
      >
        {options.map((option) => (
          <Option
            key={option.value}
            value={option.value}
            style={{ backgroundColor: "#013351", border: "none" }}
          >
            <img
              src={option.imgSrc}
              alt={option.label}
              style={{
                width: 28,
                height: 28,
                marginRight: 10,
                objectFit: "cover",
                borderRadius: "5px",
              }}
            />
            {option.label}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default ImageSelect;
